import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth-config';

export default function Login({ errorMessage }) {
  const { instance } = useMsal();

  const handleMicrosoftLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => console.error('Login error', e));
  };

  const mockLogin = (role) => {
    const mock = {
      SUPERUSER: { loginName: 'superuser', role: 'SUPERUSER' },
      ADMIN:     { loginName: 'admin',     role: 'ADMIN' },
      USER:      { loginName: 'john.doe',  role: 'USER' },
    };
    sessionStorage.setItem('Token', 'mock-token');
    sessionStorage.setItem('user', JSON.stringify(mock[role]));
    window.location.href = role === 'USER' ? '/user' : '/admin';
  };

  return (
    <div style={s.root}>
      <div style={s.logoHeader}>
        <img src="/godrej-logo-dark.svg" alt="Godrej" style={s.logo} />
        <span style={s.headerLink}>Godrej Enterprises Group</span>
      </div>

      <div style={s.row}>
        <div style={s.loginBg} />
        <div style={s.loginForm}>
          <div style={s.titleBlock}>
            <h1 style={s.h1}>TDS Certificates</h1>
          </div>

          {errorMessage && (
            <div style={s.errorBox}>
              <strong>Login Failed</strong>
              <div>{errorMessage}</div>
            </div>
          )}

          <button style={s.submitBtn} type="button" onClick={handleMicrosoftLogin}>
            Login with SSO
          </button>

          <div style={s.mockBar}>
            <span style={s.mockLabel}>Mock login:</span>
            {['SUPERUSER', 'ADMIN', 'USER'].map(r => (
              <button key={r} style={s.mockBtn} type="button" onClick={() => mockLogin(r)}>{r}</button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  root:       { position: 'relative', height: '100vh', overflow: 'hidden', fontFamily: 'var(--font-body)', color: '#707070' },
  logoHeader: { position: 'absolute', top: 0, left: 0, width: '100%', height: '56px', padding: '0 6rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #F1F1ED', background: '#fff', zIndex: 9999, boxSizing: 'border-box' },
  logo:       { height: '28px' },
  headerLink: { fontSize: '0.75rem', color: '#810055' },
  row:        { display: 'flex', height: '100vh' },
  loginBg:    { flex: '0 0 66.666%', backgroundImage: 'url(/Form16Dealers.jpg)', backgroundSize: 'cover', backgroundPosition: '0 0' },
  loginForm:  { flex: '0 0 33.333%', padding: '8rem 4rem 4rem', display: 'flex', flexDirection: 'column', overflowY: 'auto', boxSizing: 'border-box' },
  titleBlock: { marginBottom: '2rem' },
  h1:         { fontFamily: 'var(--font-headline)', fontSize: '3.75rem', color: '#810055', margin: 0, lineHeight: 1.1 },
  errorBox:   { marginBottom: '1rem', padding: '10px 14px', background: '#fdecea', color: '#c62828', fontSize: '13px', borderRadius: '4px' },
  submitBtn:  { width: '100%', padding: '1rem', background: 'var(--brand-purple)', color: '#fff', border: 'none', borderRadius: '50px', fontFamily: 'var(--font-highlight)', fontSize: '1rem', cursor: 'pointer' },
  mockBar:    { marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #F1F1ED', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' },
  mockLabel:  { fontSize: '12px', color: '#aaa' },
  mockBtn:    { padding: '4px 12px', border: '1px solid #F1F1ED', background: '#fafafa', color: '#707070', fontSize: '12px', cursor: 'pointer', borderRadius: '4px' },
};
